import React, { useState } from "react";
import { useDispatch } from "react-redux";
import ModalCustom from "../Common/ModalCustom";
import StripeCheckoutForm from "../Common/StripeCheckoutForm";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { getCurrentProduct } from "../../redux/features/SubscriptionService";
import useSubscriptionCancelRefresh from "../../hooks/useSubscriptionCancelRefresh";
import { getSubscriptionStatus } from "../../utils/subscriptionStatus";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_URL);

const SubscribedPlanDetails = ({ userId, isAdminUser }) => { // NOSONAR
  const dispatch = useDispatch();
  const [selectedProduct, setSelectedProduct] = useState();
  const [showStripeCheckoutForm, setShowStripeCheckoutForm] = useState(false);
  const { viewData, loading, isCancelling, handleCancelSubscription } =
    useSubscriptionCancelRefresh({ userId, isAdminUser });

  const formatDate = (milliseconds) => {
    if (!milliseconds) { return; }

    const date = new Date(milliseconds);
    const day = date.getUTCDate();
    const month = new Intl.DateTimeFormat('en-US', { month: 'short', timeZone: 'UTC' }).format(date);
    const year = date.getUTCFullYear();

    return `${day} ${month} ${year}`;
  };

  const getCurrentlyUseProduct = () => {
    if (viewData?.userInfo?.stripeSubscriptionId) {
      const getUserDetail = viewData.userInfo;
      dispatch(getCurrentProduct({ stripeSubscriptionId: getUserDetail.stripeSubscriptionId }))
        .then((res) => {
          if (res.type === "subscription/getCurrentProduct/fulfilled") {
            if (res.payload.paymentPlanInfo) {
              setSelectedProduct(res.payload.paymentPlanInfo);
            }
          }
        });
    }
  };

  const handleStripeCheckoutForm = () => {
    getCurrentlyUseProduct();
    setShowStripeCheckoutForm(true);
  };

  const { subscriptionDetail, stripePlan, userInfo } = viewData || {};
  const subscriptionStatus = getSubscriptionStatus(subscriptionDetail);
  const expirySeconds = userInfo?.planExpiryDate
    ? parseInt(userInfo.planExpiryDate, 10)
    : null;

  const renderSubscriptionBtn = () => {
    if (subscriptionStatus === 1) {
      return (
        <button
          className="btn btn-danger"
          onClick={handleCancelSubscription}
          disabled={isCancelling}
        >
          {isCancelling ? "Cancelling..." : "Cancel Subscription"}
        </button>
      );
    }
    if (subscriptionStatus === 2) {
      return (
        <div className="text-danger">
          <strong>Cancel At:</strong> {formatDate(expirySeconds)}
        </div>
      );
    }
    if (subscriptionStatus === 0 && !isAdminUser) {
      return (
        <div className="btn btn-secondary" onClick={handleStripeCheckoutForm}>
          <strong>Renew</strong>
        </div>
      );
    }
    return <strong className="text-danger">Cancelled</strong>;
  };

  if (!viewData && loading) {
    return null;
  }

  if (!subscriptionDetail || !stripePlan || !userInfo) {
    return null;
  }
  if ([3, 6].includes(parseInt(userInfo.role, 10))) {
    return null;
  }

  const { title, price, subTitle } = stripePlan;

  return (
    <>
      <div className="m-3 profile_main_part_section">
        <div className="mx-3">
          <h3 className="text-center pt-3">Subscription Detail</h3>
          <div className="d-flex my-3 py-3 justify-content-around px-3 bg-light border rounded-3 align-items-center">
            <div><strong>Subscription: </strong>{title}</div>
            <div><strong>Price: </strong>{price} USD</div>
            <div><strong>Type: </strong>{subTitle}</div>
            <div>{renderSubscriptionBtn()}</div>
          </div>
        </div>
      </div>

      {
        ([2, 4].includes(parseInt(userInfo.role, 10))) ? (
          <ModalCustom size="xs" show={showStripeCheckoutForm}>
            <Elements stripe={stripePromise}>
              <StripeCheckoutForm
                checkoutFormType="renew_subscription"
                selectedProduct={selectedProduct}
                handleStripeCheckoutFormPopup={setShowStripeCheckoutForm}
              />
            </Elements>
          </ModalCustom>
        ) : null
      }
    </>
  );
};

export default SubscribedPlanDetails;
